var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRatingLowPerformer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "poor-performing plan icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "poor-performing-plan-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    stroke: "#FF3333",
    strokeWidth: 2,
    fill: "#FFFFFF",
    transform: "translate(10.500000, 12.000000) rotate(-180.000000) translate(-10.500000, -12.000000) ",
    points: "10.5 8 18 16 3 16"
  }), /*#__PURE__*/React.createElement("text", {
    id: "!",
    fill: "#272727",
    fontFamily: "Montserrat-Medium, Montserrat",
    fontSize: 19,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 17
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatingLowPerformer);
export default __webpack_public_path__ + "static/media/star-rating-low-performer.27fe7dd1a1c384736c604ecf070571ed.svg";
export { ForwardRef as ReactComponent };